module.exports = __webpack_public_path__ + "media/images/features/5/main/main-2-9629324a1ee7eeb12c9892610dde8805.jpg";